export const ROUTE_PATH = '/efs-parking';

export const FEATURE_NAME = 'efsParkingPage';
